{{#with sequenceItemHandle}}
virtual function void broadcast_item({{ type }} {{ identifier }});
  {{ ../analysisPortHandle.identifier }}.write({{ identifier }});
endfunction
{{/with}}
